<script lang="ts">
  import { get,  writable } from "svelte/store";
  import ContactDropdown from "../../components/Business/ContactDropdown.svelte";
  import SearchHeader from "../../components/SearchHeader.svelte";
  import Input from "../../components/Form/Fields/Input.svelte";
  import DateInput from "../../components/Form/Fields/DateInput.svelte";
  import Switch from "../../components/Form/Fields/Switch.svelte";
  import NumberInput from "../../components/Form/Fields/NumberInput.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import InvoiceDashboard from "../../components/Business/InvoiceDashboard.svelte";
  import Table from "../../components/Table/Table.svelte";
  import type { ICompanyInvoice } from "../../entities";
  import type { ICompanyInvoiceDTO, ICompanyInvoiceEmailDTO } from "../../services/DTO";
  import CustomFields from "../../components/CustomFields/CustomFields.svelte";
  import FormLayout from "../../layout/FormLayout.svelte";
  import type { IApiResponse } from "../../utils/api/api-response";
  import { companyInvoiceEmailsDtoFields } from "../../utils/TableFields/company-invoice-emails-dto.fields";
  import OwnershipDropdown from "../../components/Form/Fields/Dropdown/OwnershipDropdown.svelte";
  import {setNull} from "../../utils/object-utils";
  import { PermissionService } from "../../utils/misc/permission-utils";
  import InvoiceEmailListEditor from "../../components/Business/InvoiceEmailListEditor.svelte";

    import { user } from "../../app.store";
  import {
    companyInvoicesEmails,
    pagination_invoicesemails,
    onPageChangeInvoiceEmails,
    filter_invoiceemails,
    searchInvoicesEmails,
    exportInvoicePdf,
    loadInvoicesEmails,
    sendEmail
  } from "./company.store";

  export let oid: number;
  let cansend : boolean = PermissionService.isAllowedTo($user, 'companyinvoices.cansend');


    function onDownload(item: ICompanyInvoiceEmailDTO) {
      if (item.invoice.urlPdf != null && item.invoice.urlPdf != "")
        exportInvoicePdf(item.invoice.oid);
    }

    function onSendemail(item: ICompanyInvoiceEmailDTO) {
      sendEmail(item.invoice.oid, item.invoice.companyId);
      resetSearchInvoicesEmails();
    }

    function resetSearchInvoicesEmails(){
      setNull($filter_invoiceemails.criteria);
      searchInvoicesEmails(oid);
    }
</script>

    <SearchHeader
      entitySingular="fattura inviata"
      entityPlural="fatture inviate"
      numRecords={$pagination_invoicesemails != null ? $pagination_invoicesemails.totalRecords : 0}
      bind:searchValue={$filter_invoiceemails.criteria.query}
      on:search={() => searchInvoicesEmails(oid)}
      on:reset={() => resetSearchInvoicesEmails()}      
      clearButtonVisible={true}
    />

  <Table
    loading={false}
    fields={companyInvoiceEmailsDtoFields}
    records={$companyInvoicesEmails}
    pagination={$pagination_invoicesemails}
    createEnabled={false}
    editEnabled={false}
    customEnabled={cansend}
    customIcon="send"
    deleteEnabled={false}
    downloadEnabled={true}
    on:custom={(e) => onSendemail(e.detail)}
    on:download={(e) => onDownload(e.detail)}
    on:pageChange={(e) => onPageChangeInvoiceEmails(oid, e.detail)}
  />
 